export const PrepaidMeterRechargeStep = {
  ReadCard: 0,
  CardData: 1,
  RechargeCalculation: 2,
  RechargeCard: 3
};

export const PrepaidMeterRechargeStepLabel = {
  [PrepaidMeterRechargeStep.ReadCard]: 'Lectura de tarjeta',
  [PrepaidMeterRechargeStep.CardData]: 'Datos de tu tarjeta',
  [PrepaidMeterRechargeStep.RechargeCalculation]: 'Calcular recarga',
  [PrepaidMeterRechargeStep.RechargeCard]: 'Recargar tu medidor'
};

export const FORM_ID = 'prepaid_meter_recharge_form';

export const PREPAID_METER_RECHARGE_STEPS = Object.values(
  PrepaidMeterRechargeStepLabel
).map(label => ({ label }));

export const MAX_RECHARGE_VALUE = 100000000;
